import { ModuleWithProviders, NgModule } from '@angular/core';

import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DragDropModule } from 'primeng/dragdrop';
import { DrawerModule } from 'primeng/drawer';
import { EditorModule } from 'primeng/editor';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PopoverModule } from 'primeng/popover';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TooltipModule } from 'primeng/tooltip';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { BlockUIModule } from 'primeng/blockui';
import { AutoFocusModule } from 'primeng/autofocus';
import { PaginatorModule } from 'primeng/paginator';
import { OrderListModule } from 'primeng/orderlist';
import { CarouselModule } from 'primeng/carousel';
import { DynamicDialogModule } from 'primeng/dynamicdialog';

const PRIME_NG_MODULES = [
  OrderListModule,
  AutoFocusModule,
  ScrollPanelModule,
  ButtonModule,
  ToastModule,
  TabsModule,
  RippleModule,
  PanelModule,
  CardModule,
  ChipModule,
  InputTextModule,
  TextareaModule,
  InputNumberModule,
  DatePickerModule,
  SelectModule,
  AutoCompleteModule,
  TableModule,
  RatingModule,
  ProgressBarModule,
  MultiSelectModule,
  EditorModule,
  ConfirmPopupModule,
  CheckboxModule,
  PopoverModule,
  BadgeModule,
  SplitButtonModule,
  DividerModule,
  TooltipModule,
  AvatarModule,
  AvatarGroupModule,
  TagModule,
  ListboxModule,
  MenuModule,
  PanelMenuModule,
  ConfirmDialogModule,
  DrawerModule,
  DialogModule,
  ProgressSpinnerModule,
  AccordionModule,
  ContextMenuModule,
  RadioButtonModule,
  StepsModule,
  SelectButtonModule,
  ToggleSwitchModule,
  BlockUIModule,
  PaginatorModule,
  CarouselModule,
  DynamicDialogModule,
  MessageModule,
  DragDropModule,
  PasswordModule,
];

@NgModule({
  imports: [PRIME_NG_MODULES],
  exports: [PRIME_NG_MODULES],
})
export class PrimeNGModule {
  public static forRoot(): ModuleWithProviders<PrimeNGModule> {
    return {
      ngModule: PrimeNGModule,
    };
  }
}
